export const LANGUAGE_CODE_TO_NAME = {
  en: 'english',
  ar: 'arabic',
  de: 'german',
  es: 'spanish',
  it: 'italian',
  pt: 'portuguese',
  fr: 'french',
  nl: 'dutch',
  ru: 'russian',
  zh: 'chinese',
}
